// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__IXefh","form":"styles_form__30pS_"};